import { AuctionStatus } from '../models/auction';

export const MockAuction = (locale: string, id: number) => ({
  id,
  href: `https://www.catawiki.com/${locale}/a/${id}-auction`,
  title: `Auction id - ${id}`,
  curator: {
    id: 0,
    name: 'Curator name',
    image_large: null,
    image_small: null,
    profile_complete: true,
  },
  mainImage: '',
  thumbImages: ['', '', ''] as [string, string, string],
  numberOfLots: 103,
  status: AuctionStatus.openNow,
  startAt: new Date().toISOString(),
  closeAt: new Date(Date.now() + 86_400_000).getTime(),
  isLiveStream: false,
  isLiveStreamEndingNow: false,
});
